
import { Component, Inject, Prop, Vue } from "vue-property-decorator"

import UserImage from "@/components/UserImage.vue"

import { CaseAudit, CaseDetails, Field } from "@/types"
import { caseColumns } from "@/types/caseColumns"
import { FieldDataTypes } from "@/types/fieldTypes"

import CaseAuditHistoryService from "@/services/caseAuditHistoryService"
import { formatDateMixin } from "@/mixins/formatDateMixin"

@Component({
	components: {
		"user-image": UserImage
	}
})
export default class History extends Vue {
	@Inject() caseAuditHistoryService!: CaseAuditHistoryService

	@Prop()
	public currentCase!: CaseDetails | null

	stringMatchesFriendlyDateAndTimeFormat = ((this as any).stringMatchesFriendlyDateAndTimeFormat)

	private get auditHistory (): CaseAudit[] {
		const auditHistory = this.caseAuditHistoryService?.auditHistory ?? []

		// Ignore audits where a text field went from null to an empty string.
		const filteredAudits = auditHistory.filter(audit => !(audit.oldValue === null && audit.newValue === ""))

		return filteredAudits
	}

	private getField (fieldId: string): Field | null {
		const caseColumn = caseColumns.firstOrDefault(c => c.key === fieldId)
		if (caseColumn) {
			return {
				id: caseColumn.key,
				title: caseColumn.label,
				dataType: caseColumn.dataType
			} as Field
		}

		const caseField = this.currentCase?.fields[fieldId]

		if (caseField) {
			return caseField.field
		}

		return null
	}

	private getFormattedAuditValue (audit: CaseAudit, newValue: boolean): string | null {
		const value = newValue ? audit.newValue : audit.oldValue
		const valueLabel = newValue ? audit.newValueLabel : audit.oldValueLabel

		let valueToDisplay = valueLabel ?? value ?? null

		if (!audit.fieldId) return valueToDisplay

		const field = this.getField(audit.fieldId)
		if (!field) return valueToDisplay

		if (field.dataType === FieldDataTypes.Date || field.dataType === FieldDataTypes.DateTime) {
			// output UTC date audits in the user's local time zone
			valueToDisplay = formatDateMixin.methods.displayDateFromISOString(value)
		}

		return valueToDisplay
	}
}
